import { useMutation } from "react-query";
import AuthService from "../services/authService";

export const useLogout = () => {
  return useMutation(AuthService.logout, {
    onSuccess: (data) => {
      console.log(data);
      localStorage.removeItem("token");
      localStorage.removeItem("cartItems");
      window.location.href = "/";
    },
    onError: (error: any) => {},
  });
};
